import { Component, ElementRef, Inject, InjectionToken, ViewEncapsulation } from '@angular/core';
import { ObjectTypes } from '@fi-shared/types';
import { Animations } from '@fi-shared/utils/animations';

export const DocumentEditItemSimpleTextPanelComponentData = new InjectionToken(
    'DocumentEditItemSimpleTextPanelComponentData',
);
export interface IDocumentEditItemSimpleTextPanelComponentData {
    closeInsertMediaDialogAfterFileSelection?: boolean;
    componentElement: HTMLElement;
}

@Component({
    selector: 'fi-document-edit-item-simple-text-panel',
    templateUrl: './simple-text-panel.component.html',
    styleUrls: ['./simple-text-panel.component.scss'],
    animations: [Animations.fade],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class DocumentEditItemSimpleTextPanelComponent {
    closeInsertMediaDialogAfterFileSelection: boolean;
    componentElement: HTMLElement;
    ObjectTypes = ObjectTypes;
    isInsertMediaButtonShown: boolean = true;

    constructor(
        @Inject(DocumentEditItemSimpleTextPanelComponentData)
        public documentEditItemSimpleTextPanelComponentData: IDocumentEditItemSimpleTextPanelComponentData,
        public elementRef: ElementRef,
    ) {
        this.closeInsertMediaDialogAfterFileSelection =
            documentEditItemSimpleTextPanelComponentData.closeInsertMediaDialogAfterFileSelection;
        this.componentElement = documentEditItemSimpleTextPanelComponentData.componentElement;
    }
}
